// Customizable Area Start
import React, { Component } from "react";
import { Box, styled, Avatar } from "@mui/material";
import clsx from "clsx";

const AvatarWrapper = styled(Box)({
  position: "relative",
  "& .MuiAvatar-root": {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    "& > img": {
      objectPosition: "top",
    },
  },
  "& .activity_indicator": {
    position: "absolute",
    right: 0,
    bottom: "6px",
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    "&.is_online": {
      bottom: "0px",
      height: "12px",
      width: "12px",
      border: "3px solid #059669",
    },
  },
});

interface BaseProps {
  url?: string;
  name: string;
  isShowStatus: boolean;
  height?: string | number;
  width?: string | number;
}

type Props = BaseProps &
  (BaseProps["isShowStatus"] extends true
    ? { isOnline: boolean }
    : { isOnline?: boolean });

class CustomAvatar extends Component<Props> {
  render() {
    const {
      url,
      name,
      isShowStatus,
      isOnline,
      height = 40,
      width = 40,
    } = this.props;

    return (
      <AvatarWrapper>
        <Avatar src={url} alt={name} sx={{ height, width }} />
        {isShowStatus && (
          <Box
            className={clsx("activity_indicator", {
              ["is_online"]: isOnline,
            })}
          />
        )}
      </AvatarWrapper>
    );
  }
}

export default CustomAvatar;
// Customizable Area End
